import { array } from 'yup';
import { PcpPatientServiceSchema } from './PcpPatientServiceSchema';

// Bug in formik, it does not show formik.errors for arrays
// https://github.com/jaredpalmer/formik/issues/1116
// Use yup validation
export const PcpPatientServiceListSchema = array()
  .of(PcpPatientServiceSchema)
  .required();
